import {Button} from "react-bootstrap";
import {useAuth} from "../../AuthUser";
import {useState} from "react";
import API from "../../api";
import {useParams} from "react-router-dom";
import moment from "moment";
import ProfileImage from "../ProfileImage";
import RichText from "../RichText";
import CommentEditor from "../CommentEditor";
import {normalizeQuillHtml, richTextHasText} from "../QuillInput";


function CommentForm() {
	const [result, setResult] = useState();
	const [disabled, setDisabled] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [html, setHtml] = useState('');

	const auth = useAuth();
	let { lessonId } = useParams();

	const noName = `user00${auth.user.id+ auth.user.id}`;

	const handleSubmit = (e) => {
		e.preventDefault();

		// The editor is the source of truth now, so an empty document is
		// "<p><br></p>" rather than "" — a truthy check would post blanks.
		if (!richTextHasText(html)) {
			return;
		}
		// Quill serializes every space as &nbsp;, which blocks wrapping wherever
		// the body is rendered later. Normalize on submit, never in onChange.
		const body = normalizeQuillHtml(html);
		setSubmitting(true);
		API.post(`lessonComments/${lessonId}`, {
			comment: body,
			bodyFormat: 'html',
			creator: auth.user.id,
		})
			.then(() => setResult(body))
			.finally(() => {
					setSubmitting(false);
					setDisabled(true);
					setHtml('');
				}
		);
	}

	const comment = (comments) => <div className="mt-5 comment-container">
		<div className='comments'>
			<div className="d-flex flex-row p-3 gap-3">
				<ProfileImage size={40} textSizeRatio={2.75} text={auth.user.email}/>
				<div className="w-100">
					<div className="d-flex justify-content-between align-items-center">
						<div className="d-flex flex-row align-items-center">
							<span className="me-2">{auth.user?.firstName || noName}</span>
							<small className="text-orange"><strong>{auth.user.admin ? 'Master Instructor' : ''}</strong></small>
						</div>
						<small>{moment().fromNow()}</small>
					</div>
					<div className="text-justify comment-text mb-0"><RichText text={comments} format="html"/></div>
				</div>
			</div>
		</div>
	</div>

	return (
		<>
			<form className="mb-5" onSubmit={handleSubmit}>
			<div className="mt-3 d-flex flex-row align-items-center gap-3">
				<CommentEditor value={html} onChange={setHtml} placeholder="Enter your comment..." readOnly={disabled}/>
			</div>
			<div className="mt-2 float-end">
				<Button size="sm" variant="primary" type="submit" disabled={disabled}>
					{isSubmitting ? (
						<>
													<span
														className="spinner-border spinner-border-sm"
														role="status"
														aria-hidden={true}
													/>{" "}
						</>
					) : (
						"Comment"
					)}
				</Button>
			</div>
			</form>
			{result ? comment(result) : ''}
		</>
	)
}

export default CommentForm;
